import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52f64f22")

_pushScopeId("data-v-52f64f22")
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "modal-close-inner" }, [
  /*#__PURE__*/_createVNode("svg", {
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("g", { "data-name": "Layer 2" }, [
      /*#__PURE__*/_createVNode("g", { "data-name": "close" }, [
        /*#__PURE__*/_createVNode("rect", {
          height: "24",
          opacity: "0",
          transform: "rotate(180 12 12)",
          width: "24"
        }),
        /*#__PURE__*/_createVNode("path", { d: "M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3\n                4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" })
      ])
    ])
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "modal-inner" }, {
      header: _withId(() => [
        _createVNode("h2", null, _toDisplayString(_ctx.title), 1),
        _createVNode(_component_Button, {
          class: "modal-close",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('close')), ["prevent"]))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withId(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ]))
})